import React from "react";
import './App.css';
import discord from './Images/discord.png';
import twitter from './Images/twitter.png';
import opensea from './Images/opensea.svg';
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link
  } from "react-router-dom";

function Navbar(){

    function shownav(){
        document.getElementById("mobilemenu").style.display = "inline-block";
    }
    return(
        <>
        <div className="container">
        <nav className="navbar navbar-expand-lg fixed-top">
                <a className="navbar-brand" href="#">CyberHouse</a>
                <button className="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
        <span className="navbar-toggler-icon"><i className="fa fa-2x fa-bars" style={{color: 'black', fontSize: '18px', backgroundColor: 'white', padding: '10px'}} aria-hidden="true" /></span>
      </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                <ul className="navbar-nav ml-auto">
                    <li className="nav-item ">
                        <Link className="nav-link" to="/">Home</Link>
                    </li>
                    <li className="nav-item">
                        <Link className="nav-link" to="/rift">RIFT</Link>
                    </li>
                    <li className="nav-item">
                    <Link className="nav-link" to="/transmission">transmission</Link>
                    </li>
                    <li className="nav-item">
                    <Link className="nav-link" to="/map">map</Link>
                    </li>
                    <li className="nav-item">
                    <Link className="nav-link" to="/"><img src={twitter} className='nav-img'/></Link>
                    </li>
                    <li className="nav-item">
                    <Link className="nav-link" to="/"><img src={discord} className='nav-img'/></Link>
                    </li>
                    <li className="nav-item">
                    <Link className="nav-link" to="/"><img src={opensea} className='nav-img'/></Link>
                    </li>
                    <li className="nav-item">
                    <Link className="nav-link connect-btn" style={{padding:"10px 40px"}} to="/">CONNECT</Link>
                    </li>
                </ul>
                </div>
            </nav>
           

           {/* <div className="mobile-nav">
       
           <i className="fa fa-2x fa-bars" onClick={shownav} style={{color: 'black', fontSize: '18px', backgroundColor: 'white', padding: '10px'}} aria-hidden="true" />

           <div className="mymenu" id="mobilemenu">
          
           <i className="fa fa-2x fa-times mobile-times" style={{color: 'black', fontSize: '18px', backgroundColor: 'white', padding: '10px'}} aria-hidden="true" />
               <ul>
                   <Link to="/"><li>Home</li></Link>
                   <Link to="/rift"><li>Rift</li></Link>
                   <Link to="/transmission"><li>transmission</li></Link>
                   <Link to="/map"><li>map</li></Link>
                    <Link to="#" className="mx-auto mylink"><li><span className="social">Twitter</span></li></Link>
                    <Link to="#" className="mx-auto mylink"><li><span className="social">Discord</span></li></Link>
                    <Link to="#" className="mx-auto mylink"><li><span className="social">Connect</span></li></Link>
               </ul>
           </div>
           </div> */}
           
           </div>
        </>
    )
}
export default Navbar;